// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";

import { ApplicationFrameContext } from "../ApplicationFrame";

import { ApplicationHelpContext } from "./ApplicationHelpContext";

export type ApplicationHelpContextProviderProps = {
	/** Primary content. */
	children?: React.ReactNode;
};

// eslint-disable-next-line max-len
export type ApplicationHelpContextProviderType =
	React.ComponentType<ApplicationHelpContextProviderProps>;

// eslint-disable-next-line max-len
export const ApplicationHelpContextProvider: ApplicationHelpContextProviderType =
	(props) => {
		const { children } = props;

		const { Provider } = ApplicationHelpContext;

		const {
			help: { open, setOpen },
		} = React.useContext(ApplicationFrameContext);

		return React.useMemo(
			() => (
				<Provider
					value={{
						open,
						setOpen,
					}}
				>
					{children}
				</Provider>
			),
			[children, open, setOpen],
		);
	};
